import { Component, Inject, OnInit, AfterViewInit, ViewChild, Pipe, ChangeDetectorRef } from '@angular/core';
import { SchedulerService } from '../scheduler.service';
import { NextApptWhenEnum } from 'src/app/models/enum/notification/next-appt-when.enum';
import { FileManagerService } from '../../file-manager/file-manager.service';
import { PatientService } from '../../patient/patient.service';
import { DialogService } from '../../../services/dialog.service';
import { StaticDataService } from '../../../services/static-data.service';
import { DoctorsService } from '../../../services/doctors.service';
import { Globals } from '../../../globals';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AppointmentDialogDataV2Model } from '../models/edit-appoitment-data-model';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { PatientHaltDialogComponent } from '../../../dialog/patient-halt-dialog/patient-halt-dialog.component';
import { PatientDataModel } from '../../../models/patient/patient-data.model';
import { PatientSearchModel } from '../../../models/patient/patient-search.model';
import { ContactCommsDataModel } from '../../../models/person/contact-comms-data.model';
import { AppointmentDetailDataModel } from '../../../models/appointments/appointment-detail-data.model';
import { DoctorQueryOptionsModel } from '../../../models/doctors/doctor-query-options.model';
import { AppointmentDataModel } from '../models/appoitment-model';
import { DoctorDataModel } from '../../../models/doctors/doctor-data.model';
import { TdoUserConfigurationModel } from '../../../models/configuration/user/tdo-user-configuration.model';
import { formatDate } from '@angular/common';
import { TdoDropdownChange } from '../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { CommMethodEnum } from '../../../models/enum/comm-method.enum';
import { PatientDialogDataModel } from '../../patient/patient-dialog-data.model';
import { PatientEditComponent } from '../../patient/patient-edit/patient-edit.component';
import { ToothUiManagerModel } from '../../tdo-shared/tooth-picker/tooth-ui-manager/tooth-ui-manager.model';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { OperatoryDataModel } from '../../../models/clients/operatory-data.model';
import { TdoPatientSearchComponent } from '../../../tdo-controls/tdo-patient-search/tdo-patient-search.component';
import { EditAppointmentSelectProcedureDialogComponent } from '../edit-appointment-select-procedure-dialog/edit-appointment-select-procedure-dialog.component';
import { ApptStatusEnum } from 'src/app/models/enum/appt-status.enum';
import { UiService } from 'src/app/services/ui.service';
import { DateTime } from 'luxon';
import {TdoNoteSaveModel} from '../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import {TdoSimpleNoteComponent} from '../../../tdo-controls/common/tdo-simple-note/tdo-simple-note.component';
import {ContactDataModel} from '../../../models/person/contact-data.model';
import CustomStore from 'devextreme/data/custom_store';
import { PatientDoctorDataModel } from '../../../models/patient/patient-doctor-data.model';
import { Constants } from '../../../constants';
import { DoctorSpecialtyDataModel } from 'src/app/models/doctors/doctor-specialty-data.model';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { DoctorTypeEnum } from 'src/app/models/enum/doctor-type.enum';

// @Pipe({
//   standalone: false,
//   name: "phone"
// })
// export class PhonePipe {
//   transform(rawNum:string) {
//     rawNum = "+1"+ rawNum;
//
//     const countryCodeStr = rawNum.slice(0,2);
//     const areaCodeStr = rawNum.slice(2,5);
//     const midSectionStr = rawNum.slice(5,8);
//     const lastSectionStr = rawNum.slice(8);
//
//     return `${countryCodeStr} (${areaCodeStr})${midSectionStr}-${lastSectionStr}`;
//   }
// }

@Component({
  standalone: false,
    selector: 'app-edit-appointment-dialog',
    templateUrl: './edit-appointment-dialog.component.html',
    styleUrls: ['./edit-appointment-dialog.component.scss']
})
export class EditAppointmentDialogComponent implements OnInit, AfterViewInit {
    @ViewChild('searchInput') patientInputSearch: TdoPatientSearchComponent;
    @ViewChild('simpleNote') simpleNote: TdoSimpleNoteComponent;


    constructor(private readonly schedulingService: SchedulerService,
                private readonly fileService: FileManagerService,
                private readonly patientService: PatientService,
                private readonly dialogService: DialogService,
                private readonly staticDataService: StaticDataService,
                private readonly doctorsService: DoctorsService,
                
                private readonly globals: Globals,
                @Inject(MAT_DIALOG_DATA) public data: AppointmentDialogDataV2Model,
                private readonly dialogRef: MatDialogRef<EditAppointmentDialogComponent>,
                private readonly dialog: MatDialog,
                private readonly changeDetectorRef: ChangeDetectorRef,
                private readonly uiService: UiService) { }
                


    public isLoading: boolean = false;
    isNewDoctorPopupVisible: boolean = false;

    isNewAppoitment: boolean = true;
    isSaving: boolean = false;

    isAppointmentDoNotAllowEdit = false;
    isAppointmentConfirmation = false;
    isAppointmentDoNotAllowEditNotes = true;
    isAppoitmentDoNotAllowProcEdit = false;

    patientPictureSrc: string = 'assets/Images/defaultPatient.PNG';
    procedureName: string = '';
    //SearchFor: string = '';
    patient: PatientDataModel;
    isWaitList: boolean = false;
    isOverrideSms: boolean = false;
    patientAppointments: AppointmentDataModel[] = [];

    toothSurfaceEnums: EnumValidValueItemModel[] = [];
    isReferralRequest: boolean = false;
    referralNote: TdoNoteSaveModel;


    newDoctorFirstName: string = '';
    newDoctorLastName: string = '';


    isAllDoctors: boolean = false;
    doctorPredicate: (data: DoctorDataModel) => string;
    userPredicate: (data: TdoUserConfigurationModel) => string;
    referringDoctorPredicate: (data: DoctorDataModel) => string;
    NextApptWhenEnum = NextApptWhenEnum;
    isCustomSmsMessage: boolean = false;
    customSmsMessage: string = '';
    originalStartDate: string = '';
    WaitListReason: string = '';


    providerDoctors: DoctorDataModel[] = [];
    locationDoctors: DoctorDataModel[] = [];
    locationDoctorsAll: DoctorDataModel[] = [];
    referringDoctors: DoctorDataModel[] = [];
    doctorDisabledPredicate: (data: DoctorDataModel) => boolean = (data: DoctorDataModel) => {
        return !data.isActiveDoctor;
    };


    sLocalStartDate: string ;
    localStartDate: Date ;
    localStartTime: Date ;
    localEndTime: Date ;

    selectDoctorBoxDataSource: CustomStore;    
    dropDownOptions = { container: document.querySelector('.cdk-overlay-container') ?? document.body };
    Referring_DoctorId: string = '';
    originalReferringDoctor: DoctorDataModel = new DoctorDataModel();
    originalReferringDoctorId: string = '';
    newReferringDoctor: DoctorDataModel;



    enumDoctorType_Provider: string = '00000004-1000-0000-0000-000000000001';
    enumApptStatus_Canceled: string = '00000072-0000-0000-0000-000000000007';
    // enumApptStatus_Confirmed: string = '00000072-0000-0000-0000-000000000008';
    enumApptStatus_UnConfirmed: string = ApptStatusEnum.Unconfirmed;

    /** Statuses that are retired and must not be offered in the Status dropdown. */
    readonly excludedApptStatusIds: string[] = [ApptStatusEnum.Created];
    enumApptType_BlockIn: string = '00000071-0000-0000-0000-000000000006';
    enumApptType_BlockOut: string = '00000071-0000-0000-0000-000000000005';


    ngAfterViewInit(): void {
        // console.log("ngAfterViewInit");
    }

    ngOnInit(): void {
        this.isWaitList = false;
        this.isAppointmentDoNotAllowEdit = false;
        this.isAppointmentDoNotAllowEditNotes = false;

        if (this.data.cancellingAppointment === true || this.data.appointment.enumApptStatusId === this.enumApptStatus_Canceled) {
            this.isAppointmentDoNotAllowEdit = true;
            this.isAppointmentDoNotAllowEditNotes = false;

            if (this.data.cancellingAppointment === true) {
                this.data.appointment.enumApptStatusId = this.enumApptStatus_Canceled;
            }
        }
        if (this.data.appointment.PatientCaseId == null || this.data.appointment.PatientCaseId == '') {

            this.isAppoitmentDoNotAllowProcEdit = false;
        }
        else {
            this.isAppoitmentDoNotAllowProcEdit = true;
        }

        if (this.data.confirmingAppointment === true) {
            this.isAppointmentDoNotAllowEdit = true;
            this.isAppointmentDoNotAllowEditNotes = false;

            if (this.data.confirmingAppointment === true) {
                this.data.appointment.enumApptStatusId = ApptStatusEnum.Confirmed;
            }
        }

        if (this.data.appointment.AppointmentId) {
            // EDITING:  load patient info
            //           load all else

            if (this.data.appointment.isReservation === true) {

                if (this.data.appointment.PatientId == null || this.data.appointment.CaseProcedureId == null) {
                    this.isNewAppoitment = true;
                }

            }
            else {
                this.isNewAppoitment = false;
            }


            if (this.data.appointment.dataAppoitmentDetails.length == 0) {
                this.schedulingService.getAppoitmnetDetailes(this.data.appointment.AppointmentId).subscribe(res => {
                    this.data.appointment.dataAppoitmentDetails = res;

                    const z = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'isWaitListReason');
                    if (z) {
                        this.isWaitList = true;
                        this.WaitListReason = z.DetailParameterValue;
                    }

                    this.getReferringDoctor();
                    this.changeDetectorRef.markForCheck();
                });
            }

            this.onPatientSearchSelectionChanged({ PatientId: this.data.appointment.PatientId } as PatientSearchModel);

        }

        // 0123456789012345
        // 2025-07-20 10:00
        if (this.data.appointment.startDate.includes('T')) {
            this.data.appointment.startDate = this.data.appointment.startDate.replaceAll('T', ' ').substring(0, 16  );
            this.data.appointment.endDate = this.data.appointment.endDate.replaceAll('T', ' ').substring(0, 16  );
        }

        this.sLocalStartDate = this.data.appointment.startDate.toString().substring(0, 10);
        this.localStartDate = this.getDate(this.data.appointment.startDate);
        this.localStartTime = this.getTime(this.data.appointment.startDate);
        this.localEndTime = this.getTime(this.data.appointment.endDate);

        this.originalStartDate = this.data.appointment.startDate;
        this.referringDoctors = this.data.allDoctors;
        this.referringDoctorPredicate = (data: DoctorDataModel) => 'Dr. ' + data.dataContact.LastName + ', ' + data.dataContact.FirstName + (data.enumDoctorTypeID === '00000004-1000-0000-0000-000000000001' ? '  (TDO)' : '  (REF)');
        this.doctorPredicate = (data) => 'Dr. ' + data.dataContact.LastName + ', ' + data.dataContact.FirstName;
        this.refreshProcedureName();
        this.setupValidValues();



        if (this.globals.ReferralAppointmentRequest && (this.data.appointment.PatientId === null || this.data.appointment.PatientId === undefined )) {
            this.dialogService.openConfirmDialog('Create Appointment based on Referral Request ?').subscribe((result) => {
                if (result === true) {
                    this.loadReferralInformation();
                } else {
                    this.isReferralRequest = false;
                    this.globals.ReferralAppointmentRequest = null;
                }

            });
        }


        this.data.appointment.enumApptStatusId ??= ApptStatusEnum.Unconfirmed;

        this.selectDoctorBoxDataSource = new CustomStore({
            key: 'DoctorId',
            load: (loadOptions) => {
              const searchValue = loadOptions.searchValue || '';
              
              // Validate searchValue before making API call
              if (!searchValue || searchValue.trim() === '') {
                // Return empty array if no search value provided
                return Promise.resolve([]);
              }
              
              return firstValueFrom(this.doctorsService.searchForDoctors(searchValue).pipe(
                map(res => res.filter(d => d.isActiveDoctor))
              ))
              .then((res) => {
                this.changeDetectorRef.markForCheck();
                return res;
              });
            },
            byKey: (key) => {
              // Validate key before making API call
              if (!key) {
                return Promise.resolve(null);
              }
              
              // Implement logic to retrieve a single item by its key
              // This could involve fetching from an API or searching local data
              return firstValueFrom(this.doctorsService.searchForDoctors(key))
              .then((res) => {
                this.changeDetectorRef.markForCheck();
                return Array.isArray(res) ? res.find(d => d.DoctorId === key) || null : res;
              });
            }
          });
    }

    onNewDoctorClickHandler(event: any) {
        
        this.isNewDoctorPopupVisible = true;
    }

    onNewDoctorPopupHidden(event: any) {
        
        this.isNewDoctorPopupVisible = false;
    }

    onNewDoctorSave(event: any) {
        

        if(this.newDoctorFirstName === '' || this.newDoctorLastName === '') {
            return;
        }
        const docModel = new DoctorDataModel();
        docModel.dataContact = new ContactDataModel();
        docModel.dataContact.FirstName = this.newDoctorFirstName;
        docModel.dataContact.LastName = this.newDoctorLastName;
    
        // TODO: Either add doctor location / work days, or change backend from using the appointment controller which inner joins against these.
    
        docModel.enumDoctorClassificationID = '00000006-1000-0000-0000-000000000001';
        docModel.enumDoctorTypeID = '00000004-1000-0000-0000-000000000002';
        docModel.LOCID = parseInt(this.globals.LOCID);

        // set Dentist (GP) as the Specialty.
        const defaultGpSpecialtyId: string= '00000005-1000-0000-0000-000000000003';
        docModel.dataDoctorSpecialties = [];
        const newDoctorSpecialty = new DoctorSpecialtyDataModel();
        newDoctorSpecialty.DoctorSpecId = null;
        newDoctorSpecialty.enumMedicalSpecialtyID = defaultGpSpecialtyId;
        newDoctorSpecialty.isPrimary = true;
        docModel.dataDoctorSpecialties.push(newDoctorSpecialty);
        this.doctorsService.callPutdataDoctor4CfgDr(true, docModel).subscribe((res) => {
           this.Referring_DoctorId = res.DoctorId;
           this.changeDetectorRef.markForCheck();
        });
     
     
     
        this.isNewDoctorPopupVisible = false;
    }




    onReferringDoctorValueChanged(event: any) {
        if (!this.patient) {
            return;
        }

        const details = this.data.appointment.dataAppoitmentDetails;
        if (!details) {
            this.data.appointment.dataAppoitmentDetails = [];
        }
        if (details) {
            var  detail = details.find(p => p.DetailParameterName === 'Referring_DoctorId');
            if (detail) {
                detail.DetailParameterValue = this.Referring_DoctorId;

            } 
            else {
                const ref = new AppointmentDetailDataModel();
                ref.DetailParameterName = 'Referring_DoctorId';
                ref.DetailParameterValue = this.Referring_DoctorId;
                ref.AppointmentId = this.data.appointment.AppointmentId;
                this.data.appointment.dataAppoitmentDetails.push(ref);

            }
        }
    }

    private setupValidValues(): void {
        this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');

        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isLazyLoad = false;
        doctorQueryModel.isActiveOnly = false;
        doctorQueryModel.isIncludeReferring = false;
        doctorQueryModel.LOCID = parseInt(this.data.currentLocationId);
        this.doctorsService.getDoctorsForDoctorLocationV2(doctorQueryModel).subscribe((locationDoctors) => {

            this.locationDoctorsAll = locationDoctors;
            this.locationDoctors = locationDoctors.filter((d: DoctorDataModel) => d.isActiveDoctor === true);
            this.providerDoctors = this.getProviderDoctorOptions();

            if (this.providerDoctors.length == 1) {
                if (!(this.data.appointment?.Label_DoctorId)  )
                {
                    this.data.appointment.Label_DoctorId = this.providerDoctors[0].DoctorId;
                }
            }
            this.changeDetectorRef.markForCheck();
        });

    }

    loadReferralInformation() {
        this.isReferralRequest = true;
        this.loadPatient(this.globals.ReferralAppointmentRequest.PatientID);
        // Add Referral Doc info
        const ReferralDocIdDetail1 = new AppointmentDetailDataModel();
        ReferralDocIdDetail1.DetailParameterName = 'Referring_DoctorId';
        ReferralDocIdDetail1.DetailParameterValue = this.globals.ReferralAppointmentRequest.ReferralDoctorID;
        ReferralDocIdDetail1.AppointmentId = this.data.appointment.AppointmentId;
        this.data.appointment.dataAppoitmentDetails.push(ReferralDocIdDetail1);
        // Select Provider Doc from Referral
        this.data.appointment.Label_DoctorId = this.globals.ReferralAppointmentRequest.ProviderId;
        // select Teeth
        const teeth = this.globals.ReferralAppointmentRequest.Teeth;
        // Split the string into an array of values
        const teethValues = teeth.split(',');
        const modifiedValues = teethValues.map(value => `#${value.trim()}`);
        this.data.appointment.Subject = modifiedValues.join(' ; ');
        // adding notes
        this.data.appointment.Description = this.globals.ReferralAppointmentRequest.AppNotes;
        this.simpleNote.note.Note = this.globals.ReferralAppointmentRequest.Notes;
        this.referralNote = new TdoNoteSaveModel();
        this.referralNote.text = this.globals.ReferralAppointmentRequest.ReferralNotes;
    }

    loadPatient(PatientId: string) {
        this.isLoading = true;

        this.patientService.getPatient(PatientId).subscribe((userRes) => {

            this.loadSelectedPatient(userRes.ThePatient, null);

            const doctorQueryModel = new DoctorQueryOptionsModel();
            doctorQueryModel.isIncludeTdo = true;
            doctorQueryModel.isIncludeReferring = true;
            doctorQueryModel.PatientId = PatientId;

            if (this.data.allDoctors.length == 0  ) {
                this.doctorsService.getDoctorsSummary(doctorQueryModel).subscribe((allDoctors) => {
                // this.allDocsList = allDoctors;
                    this.data.allDoctors = allDoctors as any;
                    this.referringDoctors = this.data.allDoctors;
                });
            }
            else {
                this.referringDoctors = this.data.allDoctors;
            }

            this.isLoading = false;
            this.fileService.getPatientPicture(PatientId).subscribe((res) => {
                if (res) {
                    this.patientPictureSrc = this.fileService.getDocumentUrlFromDocument(res);
                } else {
                    this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
                }
            });
            if (userRes.ThePatient.isDoNotSchedule || userRes.ThePatient.isDoNotEverTreatAgain || userRes.ThePatient.isSentCollection || userRes.ThePatient.isDeceased) {
                const config = new MatDialogConfig();
                config.data = userRes.ThePatient;
                config.panelClass = 'dialog';

                this.dialog.open(PatientHaltDialogComponent, config).afterClosed().subscribe((res) => {
                    if (res) {
                        this.loadSelectedPatient(userRes.ThePatient, null);
                    }
                });
            } else {
                this.loadSelectedPatient(userRes.ThePatient, null);
            }
        });

        this.patientAppointments = [];
        this.schedulingService.getAllPatientAppointments(this.globals.TDOCID, PatientId).subscribe((res) => {
            this.patientAppointments = res;
            // this.appointmentTable.updateData(this.patientAppointments);
        });
    }





    // patient search autocomplete
    displayFn(patient: any): string {
        if (patient && patient.FirstName && patient.LastName) {
            return patient.FirstName + ' ' + patient.LastName;
        }
        return '';
    }

    onPatientSearchSelectionChanged(e: PatientSearchModel) {
        const _patient = e;

        if (!_patient) {
            return;
        }
        this.data.appointment.PatientId = _patient.PatientId;
        if (this.data.appointment.PatientId) {
            this.patientService.getPatient(this.data.appointment.PatientId).subscribe((userRes) => {
                this.data.appointment.PatientName = userRes.ThePatient.dataContact.FirstName + ' ' + userRes.ThePatient.dataContact.LastName;
                this.data.appointment.PatientFullInfo = '{\"FirstName\": \"' + userRes.ThePatient.dataContact.FirstName + '\", \"LastName\": \"' + userRes.ThePatient.dataContact.LastName + '\" }';

                this.fileService.getPatientPicture(this.data.appointment.PatientId).subscribe((res) => {
                    if (res) {
                        this.patientPictureSrc = this.fileService.getDocumentUrlFromDocument(res);
                    } else {
                        this.patientPictureSrc = 'assets/Images/defaultPatient.PNG';
                    }
                });
                if (userRes.ThePatient.isDoNotSchedule || userRes.ThePatient.isDoNotEverTreatAgain || userRes.ThePatient.isSentCollection || userRes.ThePatient.isDeceased) {
                    const config = new MatDialogConfig();
                    config.data = userRes.ThePatient;
                    config.panelClass = 'dialog';

                    this.dialog.open(PatientHaltDialogComponent, config).afterClosed().subscribe((res) => {
                        if (res) {
                            this.loadSelectedPatient(userRes.ThePatient, null);
                        }
                    });
                } else {
                    this.loadSelectedPatient(userRes.ThePatient, null);
                }
            });

            this.patientAppointments = [];
            this.schedulingService.getAllPatientAppointments(this.globals.TDOCID, this.data.appointment.PatientId).subscribe((res) => {
                this.patientAppointments = res;
                // this.appointmentTable.updateData(this.patientAppointments);
            });
        }
    }

    loadSelectedPatient(patient: PatientDataModel, user: PatientSearchModel) {
        this.patient = patient;
        this.data.appointment.PatientId = this.patient.PatientId;
        if (this.data.appointment.dataAppoitmentDetails === null) {
            this.data.appointment.dataAppoitmentDetails = [];
        }
        // this.isWaitList = false;
        this.isOverrideSms = false;
        this.refreshProcedureName();
        this.changeDetectorRef.markForCheck();

        
        /// Disable automatic selection of communications. COMMS template will replace this functionality.
        // Only auto-enable a channel for preferred methods the patient has NOT opted out of.
        // const preferred = this.patient.dataContact.dataContactComms.filter(p => ContactCommsDataModel.isAutoSendEligible(p));
        // for (const pref of preferred) {
        //     switch (pref.enumCommMethodID) {
        //     case '00000009-1000-0000-0000-000000000004':
        //         // EMAIL
        //         let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendEmail');
        //         if (detail) {
        //             detail.DetailParameterValue = 'true';
        //         } else {
        //             detail = new AppointmentDetailDataModel();
        //             detail.DetailParameterName = 'sendEmail';
        //             detail.DetailParameterValue = 'true';
        //             detail.AppointmentId = this.data.appointment.AppointmentId;

        //             this.data.appointment.dataAppoitmentDetails.push(detail);
        //         }

        //         break;
        //     case '00000009-1000-0000-0000-000000000003':
        //         // MOBILE
        //         let detail1 = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendSMS');
        //         if (detail1) {
        //             detail1.DetailParameterValue = 'true';
        //         } else {
        //             detail1 = new AppointmentDetailDataModel();
        //             detail1.DetailParameterName = 'sendSMS';
        //             detail1.DetailParameterValue = 'true';
        //             detail1.AppointmentId = this.data.appointment.AppointmentId;
        //             this.data.appointment.dataAppoitmentDetails.push(detail1);
        //         }

        //         break;
        //     }
        // }

        if (user) {
            this.data.appointment.PatientId = user.PatientId;
        }


        const doctorQueryModel = new DoctorQueryOptionsModel();
        doctorQueryModel.isIncludeTdo = true;
        doctorQueryModel.isIncludeReferring = true;
        doctorQueryModel.PatientId = this.data.appointment.PatientId;
        this.doctorsService.getDoctorsSummary(doctorQueryModel).subscribe((allDoctors) => {
            this.data.allDoctors = allDoctors as any;
            let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');
            if (detail == null) {
                this.patientService.getPatientReferringDoctor(this.data.appointment.PatientId).subscribe((res) => {
                    if (res && res.DoctorId && res.isActiveDoctor != false && this.data.appointment) {
                        this.Referring_DoctorId = res.DoctorId;
                        // Store the original referring doctor ID for comparison
                        if (!this.originalReferringDoctorId) {
                            this.originalReferringDoctorId = res.DoctorId;
                        }
                            detail = new AppointmentDetailDataModel();
                            detail.DetailParameterName = 'Referring_DoctorId';
                            detail.DetailParameterValue = res.DoctorId;
                            detail.AppointmentId = this.data.appointment.AppointmentId;
                            this.data.appointment.dataAppoitmentDetails.push(detail);
                        this.changeDetectorRef.markForCheck();
                    }
                });
            } else {
                // Store the original referring doctor ID if it exists in appointment details
                if (!this.originalReferringDoctorId && detail.DetailParameterValue) {
                    this.originalReferringDoctorId = detail.DetailParameterValue;
                    this.Referring_DoctorId = detail.DetailParameterValue;
                }
            }
            this.changeDetectorRef.detectChanges();
        });

        this.data.appointment.PatientName = this.patient.dataContact.FirstName + ' ' + this.patient.dataContact.LastName;
        this.data.appointment.PatientFullInfo = '{\"FirstName\": \"' + this.patient.dataContact.FirstName + '\", \"LastName\": \"' + this.patient.dataContact.LastName + '\" }';

        //this.SearchFor = '';

    }


    launchPatientDetails() {
        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;
        dm.title = 'Edit Patient';        
        dm.loadPatient = false;
        dm.entityId = this.patient.PatientId;

        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '600px';
        config.panelClass = 'tdo-note-dialog-main';
        config.data = dm;
        const dialogRef = this.dialog.open(PatientEditComponent, config);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (result.patientDeleted) {
                    // Patient was deleted, close the appointment dialog
                    this.dialogRef.close({ patientDeleted: true });
                    return;
                }
                const patientInfo = JSON.parse(this.data.appointment.PatientFullInfo);
                patientInfo.FullName = `${result.ThePatient.dataContact.FirstName} ${result.ThePatient.dataContact.LastName}`;
                this.data.appointment.PatientFullInfo = JSON.stringify(patientInfo);
                this.patient = result.ThePatient;

                this.loadSelectedPatient(result.ThePatient, null);
            }
        }, err => {
            console.error(err);
        });
    }

    getPatientPhoneNumber() {
        if (this.patient) {
            const phoneNums = this.patient.dataContact.dataContactComms.filter(p => p.enumCommMethodID === CommMethodEnum.Phone || p.enumCommMethodID === CommMethodEnum.Mobile);
            if (phoneNums.length > 0) {
                const preferred = phoneNums.find(p => p.isPreferred);
                if (preferred) {
                    return preferred.Address;
                } else {
                    return phoneNums[0].Address;
                }
            }
        }

        return '';
    }
    gotoPatientLedger() {

    }

    // onNewPatientClick() {
    //     this.dialogService.openPatientDialog(null).afterClosed().subscribe((res) => {
    //         if (res) {
    //             this.loadSelectedPatient(res, null);
    //         }
    //     });
    // }
    onNewPatientClick() {

        const dm = new PatientDialogDataModel();
        dm.mode = PatientDialogDataModel.MODE_NEW_PATIENT;
        dm.title = 'New Patient';
        dm.loadPatient = false;
        dm.entityType = PatientDialogDataModel.TYPE_PATIENT;

        const config = new MatDialogConfig();
        config.width = '968px';
        config.height = '562px';
        config.panelClass = 'tdo-note-dialog-main';
        config.data = dm;
        const dialogRef = this.dialog.open(PatientEditComponent, config);

        dialogRef.afterClosed().subscribe(result => {

            if (!result) {
                return;
            }
            this.onPatientSearchSelectionChanged({PatientId: result.ThePatient.PatientId} as PatientSearchModel);

        }, err => {
        });
    }

    getReferringDoctor() {
        const details = this.data.appointment.dataAppoitmentDetails;
        if (!details) {
            this.data.appointment.dataAppoitmentDetails = [];
        }
        if (details) {
            const detail = details.find(p => p.DetailParameterName === 'Referring_DoctorId');
            if (detail) {

                this.Referring_DoctorId = detail.DetailParameterValue;
                // Store the original referring doctor ID for comparison
                if (!this.originalReferringDoctorId) {
                    this.originalReferringDoctorId = detail.DetailParameterValue;
                }

              
            }
         
        }


    }

    onReferringDoctorChange(event: TdoDropdownChange) {
        const doc = event.value as DoctorDataModel;
        let ref = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'Referring_DoctorId');
        if (!ref && doc) {
            ref = new AppointmentDetailDataModel();
            ref.DetailParameterName = 'Referring_DoctorId';
            ref.DetailParameterValue = doc.DoctorId;
            ref.AppointmentId = this.data.appointment.AppointmentId;
            this.data.appointment.dataAppoitmentDetails.push(ref);
            this.Referring_DoctorId = doc.DoctorId;
        } else {
            if (doc) {
                ref.DetailParameterValue = doc.DoctorId;
                this.Referring_DoctorId = doc.DoctorId;
            }
        }
    }


    clearReferring() {        
        let refIndex = this.data.appointment.dataAppoitmentDetails.findIndex(p => p.DetailParameterName === 'Referring_DoctorId');
        if (refIndex !== -1) {
            this.data.appointment.dataAppoitmentDetails.splice(refIndex, 1);
        }
        this.Referring_DoctorId = '';
        return;
    }


    getDateLocal(d: Date | string) {
        const a = new Date(d);

        const y = a.getFullYear();
        const m = String(a.getMonth() + 1).padStart(2, '0');
        const i = String(a.getDate()).padStart(2, '0');

        return `${y}-${m}-${i}`;
    }
    getDateTimeLocal(d: Date | string) {
        const a = new Date(d);

        const y = a.getFullYear();
        const m = String(a.getMonth() + 1).padStart(2, '0');
        const i = String(a.getDate()).padStart(2, '0');

        const h = String(a.getHours()).padStart(2, '0');
        const mi = String(a.getMinutes()).padStart(2, '0');




        return `${y}-${m}-${i} ${h}:${mi}`;
    }




    getTime(d: Date | string) {

        return this.parseLocalDateTime(d);
    }

    getDate(d: Date | string) {
        return this.parseLocalDateTime(d);
    }

    // Parse the appointment's local date-time string tolerating an optional seconds
    // component. onSaveClick() rewrites startDate/endDate as 'yyyy-MM-dd HH:mm:ss'; if a
    // save is then blocked, the block view re-parses that value, so accepting both the
    // seconds and no-seconds forms prevents the times from rendering as 'NaN:NaN'.
    private parseLocalDateTime(d: Date | string): Date {
        const value = d.toString();
        let parsed = DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss');
        if (!parsed.isValid) {
            parsed = DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm');
        }
        return parsed.toJSDate();
    }

    onAppointmentDateChange(event: any) {
        if (!event) {
            event = this.getDate(this.data.appointment?.startDate);
        }
        const [year, month, day] = event.split('-').map(Number);
        const nd = new Date(event);
        const y = nd.getFullYear();
        const m = String(nd.getMonth() + 1).padStart(2, '0');
        const d = String(nd.getDate()).padStart(2, '0');

        let dt = new Date(this.data.appointment.startDate);
        let  h =  String(dt.getHours()).padStart(2, '0');
        let  mi = String(dt.getMinutes()).padStart(2, '0');
        this.data.appointment.startDate =  `${y}-${m}-${d} ${h}:${mi}`;

        dt = new Date(this.data.appointment.endDate);
        h =  String(dt.getHours()).padStart(2, '0');
        mi = String(dt.getMinutes()).padStart(2, '0');
        this.data.appointment.endDate =  `${y}-${m}-${d} ${h}:${mi}`;
    }
    getCombineDateTime(dateObject: Date, timeObject: Date, fixDay: boolean) {
        // Extract date components from dateObject
        const year = dateObject.getFullYear();
        const month = dateObject.getMonth();
        const day = fixDay ? dateObject.getDate() + 1 : dateObject.getDate();

        // Extract time components from timeObject
        const hours = timeObject.getHours();
        const minutes = timeObject.getMinutes();
        const seconds = timeObject.getSeconds();

        return new Date(year, month, day, hours, minutes, seconds);

    }


    onStartDateChange(event) {
        this.localStartTime = DateTime.fromFormat( this.sLocalStartDate + ' ' + String(event.getHours()).padStart(2, '0') + ':' + String(event.getMinutes()).padStart(2, '0') , 'yyyy-MM-dd HH:mm', 'en-US').toJSDate();
    }
    onEndDateChange(event) {
        this.localEndTime = DateTime.fromFormat( this.sLocalStartDate + ' ' + String(event.getHours()).padStart(2, '0') + ':' + String(event.getMinutes()).padStart(2, '0') , 'yyyy-MM-dd HH:mm', 'en-US').toJSDate();
    }


    selectAppointmentTooth() {
        this.dialogService.openToothPicker(true).subscribe((res: ToothUiManagerModel[]) => {
            //
            this.data.appointment.Subject = '';
            let i = 0;
            for (const t of res) {
                if (i > 0) {
                    this.data.appointment.Subject += ' ; ';
                }
                this.data.appointment.Subject += '#' + t.toothModel.cfgToothDescriptions[0].Notation;
                if (t.selectedSurfaceIds && t.selectedSurfaceIds.length > 0) {
                    this.data.appointment.Subject += ' (';
                    let id = 0;
                    for (const s of t.selectedSurfaceIds) {
                        if (id > 0) {
                            this.data.appointment.Subject += ',';
                        }
                        this.data.appointment.Subject += this.toothSurfaceEnums.find(p => p.ValidValueItemId.toLowerCase() === s.toLowerCase()).ItemSValue;
                        id++;
                    }
                    this.data.appointment.Subject += ')';
                }
                i++;
            }
            this.changeDetectorRef.detectChanges();
        });
    }


    onProcedureClick() {

        if (this.data.appointment.PatientId == null) {
            this.uiService.displayMessage('error', 'Please select a patient first.');
            return;
        }


        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.data;
        config.width = '600px';
        config.height = '900px';

        this.dialog.open(EditAppointmentSelectProcedureDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {
                if (res.type == 'new') {
                    this.data.appointment.ForProcedure = res.ProcedureName;
                    this.data.appointment.ApptReasonId = res.ReasonId;
                    this.data.appointment.ApptReasonDescription = res.Reason;
                    this.data.appointment.CaseProcedureId = res.CaseProcedureID;
                    this.data.appointment.isExistingCase =  false;
        
                    const minutes = parseInt(res.ReasonLength, 10);
                    if (!isNaN(minutes) && minutes > 0) {
                        let z = DateTime.fromJSDate(this.localStartTime).plus({ minutes });
                        let endDate =  z.toFormat( 'yyyy-MM-dd HH:mm');
                        this.localEndTime = DateTime.fromFormat(endDate , 'yyyy-MM-dd HH:mm', 'en-US').toJSDate();
                    }
                }
                if (res.type == 'case') {
                    this.data.appointment.PatientCaseId = res.PatientCaseId;
                    this.data.appointment.CaseWorkItemId = res.CaseWorkItemId;
                    this.data.appointment.ForProcedure = res.ProcedureName;
                    this.data.appointment.isExistingCase =  true;
                    this.data.appointment.ApptReasonId = res.ReasonId;
                    this.data.appointment.ApptReasonDescription = res.Reason;

                    if (res.EnumCaseFollowupReason) {
                        if (this.data.appointment.Subject) {
                            this.data.appointment.Subject += ' - ' + res.EnumCaseFollowupReason;
                        }
                        else
                        {
                            this.data.appointment.Subject = res.EnumCaseFollowupReason;
                        }
                    }
                }
                this.refreshProcedureName();
                this.changeDetectorRef.detectChanges();
            }
        });
    }
    private refreshProcedureName(): void {
        if (this.data.appointment.CaseProcedureId) {
            const proc = this.data.procedures.find(p => p.CaseProcedureId.toLowerCase() === this.data.appointment?.CaseProcedureId?.toLowerCase());
            this.procedureName = proc
                ? (this.data.appointment.ApptReasonDescription ?? '') + ' - ' + (proc.ProcedureName ?? '')
                : '';
        } else {
            this.procedureName = (this.data.appointment.ApptReasonDescription ?? '') + ' - ' + (this.data.appointment.ForProcedure ?? '');
        }
    }

    getProcedureName() {
        this.refreshProcedureName();
        return this.procedureName;
    }

    getPatientFlagTooltip(flag: string) {


    }
    getPatientFlagImage(flag: string) {

        // console.log(flag);
    }
    onAllDoctorsChange(e) {
        this.isAllDoctors = e.checked;
        if (this.isAllDoctors) {

            this.providerDoctors = this.data.allDoctors.filter(
                p => p.enumDoctorTypeID?.toLowerCase() === DoctorTypeEnum.PROVIDER.toLowerCase()
            );
        } else {
            this.providerDoctors = this.getProviderDoctorOptions();
        }
        this.changeDetectorRef.detectChanges();
    }

    getProviderDoctorOptions(): DoctorDataModel[] {
        const assignedId = this.data.appointment?.Label_DoctorId;
        if (assignedId && !this.locationDoctors.some(d => d.DoctorId.toLowerCase() === assignedId.toLowerCase())) {
            const inactiveAssigned = this.locationDoctorsAll.find(d => d.DoctorId.toLowerCase() === assignedId.toLowerCase());
            if (inactiveAssigned) {
                return [...this.locationDoctors, inactiveAssigned];
            }
        }
        return this.locationDoctors;
    }

    getProviderDoctor() {

        // console.log('The provider get doctor ', this.data.appointment.Label_DoctorId);

        if (this.data.appointment?.Label_DoctorId) {
            const dr = this.providerDoctors.find(p => p.DoctorId.toLowerCase() === this.data.appointment?.Label_DoctorId.toLowerCase());
            if (dr) {
                return dr;
            }
        }
        return null;
    }
    onProviderDoctorChange(e) {

        let doc: any = null;

        try {
            doc = e.value as DoctorDataModel;
        } catch (error: unknown) {
            doc = e.value[0] as DoctorDataModel;    
        }



        // console.log('The provider doctor cahnge ', doc);
        if (doc) {
            this.data.appointment.Label_DoctorId = doc.DoctorId;
        }
    }

    getOperatory() {
        const op = this.data.operatories.find(p => p.OperatoryId?.toLowerCase() === this.data.appointment?.OperatoryId?.toLowerCase());
        if (op) {
            return op;
        }
        return null;
    }
    onOperatoryChange(e) {
        const op = e.value as OperatoryDataModel;
        this.data.appointment.OperatoryId = op.OperatoryId;
    }
    onSecondaryOperatoryChange(e) {
        if (!e.isUserInput) {
            return;
        }
        this.data.appointment.secondaryOperatorys = [];
        for (const op of e.value as OperatoryDataModel[]) {
            this.data.appointment.secondaryOperatorys.push(op.OperatoryId);
        }

    }
    getAdditionalOpsList() {
        return this.data.operatories.filter(p => p?.OperatoryId?.toLowerCase() !== this.data.appointment?.OperatoryId?.toLowerCase());
    }

    getSecondOperatories(): any[] {
        return [];
    }
    onSecondOperatoryClosed(e) {

    }
    checkDetailBool(detailName: string) {
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            const detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (detail) {
                return detail.DetailParameterValue === 'true';
            }
        }
    }
    onDetailChange(event: MatCheckboxChange, detailName: string) {
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            let detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (!detail) {
                detail = new AppointmentDetailDataModel();
                detail.AppointmentId = appt.AppointmentId;
                detail.DetailParameterName = detailName;
                if (event.checked) {
                    detail.DetailParameterValue = 'true';
                } else {
                    detail.DetailParameterValue = 'false';
                }
                if (!this.data.appointment.dataAppoitmentDetails) {
                    this.data.appointment.dataAppoitmentDetails = [];
                }
                this.data.appointment.dataAppoitmentDetails.push(detail);
            } else {
                if (event.checked) {
                    detail.DetailParameterValue = 'true';
                } else {
                    detail.DetailParameterValue = 'false';
                }
            }
        }

    }
    onEarlierAppointment(e) {
        this.isWaitList = e.checked;
        if (this.isWaitList === false) {
            this.WaitListReason = '';
            this.onDetailValueChange(this.isWaitList, this.WaitListReason, 'isWaitListReason');

        }
    }

    onEarlierAppointmentReason(event: string) {
        this.WaitListReason = event;
        this.onDetailValueChange(this.isWaitList, this.WaitListReason, 'isWaitListReason');
    }



    checkDetailValueBool(detailName: string, value: string) {

    }
    onDetailValueChange(check: boolean, value: string, detailName: string) {

        // console.log(`onDetailValueChange ${detailName}` ,check, value );
        value = value != '' ? value : null;
        const appt = this.data.appointment;
        if (appt.dataAppoitmentDetails) {
            let detail = appt.dataAppoitmentDetails.find(p => p.DetailParameterName.toLowerCase() === detailName.toLowerCase());
            if (!detail) {
                detail = new AppointmentDetailDataModel();
                detail.AppointmentId = appt.AppointmentId;
                detail.DetailParameterName = detailName;
                detail.DetailParameterValue = check ? value : null;
                if (!this.data.appointment.dataAppoitmentDetails) {
                    this.data.appointment.dataAppoitmentDetails = [];
                }
                this.data.appointment.dataAppoitmentDetails.push(detail);
            } else {
                detail.DetailParameterValue = check ? value : null;
            }
            // console.log(`onDetailValueChange ${detailName} detail` , detail);
        }
    }

    onCancellationCallTaskChange(vvid: any, taskCheckbox: MatCheckbox, dateTimeControl: HTMLInputElement) {
        taskCheckbox.checked = true;

        let vv = '';

        if (typeof  vvid === 'string' ) {
            vv = vvid;
        }
        else {
            // i have no idea why ????
            if ( typeof vvid.ValidValueItemId  == 'string') {
                vv = vvid.ValidValueItemId;
            }
            else {
                vv = vvid.ValidValueItemId.ValidValueItemId;
            }


        }


        const date = new Date();
        let daysToAdd = 0;

        switch (vv) {
        case NextApptWhenEnum.NONE:
        case NextApptWhenEnum.CONVENIENCE:
        case NextApptWhenEnum.RECALL:
            daysToAdd = 0;
            break;
        case NextApptWhenEnum.ONE_DAY:
            daysToAdd = 1;
            break;
        case NextApptWhenEnum.TWO_DAYS:
            daysToAdd = 2;
            break;
        case NextApptWhenEnum.THREE_DAYS:
            daysToAdd = 3;
            break;
        case NextApptWhenEnum.THIRTY_DAYS:
            daysToAdd = 30;
            break;
        case NextApptWhenEnum.SIXTY_DAYS:
            daysToAdd = 60;
            break;
        case NextApptWhenEnum.NINETY_DAYS:
            daysToAdd = 90;
            break;
        case NextApptWhenEnum.ONE_WEEK:
            daysToAdd = 7;
            break;
        case NextApptWhenEnum.ONE_AND_HALF_WEEKS:
            daysToAdd = 10;
            break;
        case NextApptWhenEnum.TWO_WEEKS:
            daysToAdd = 14;
            break;
        case NextApptWhenEnum.THREE_WEEKS:
            daysToAdd = 21;
            break;
        case NextApptWhenEnum.SIX_WEEKS:
            daysToAdd = 42;
            break;
        case NextApptWhenEnum.SIX_MONTHS:
            daysToAdd = 180;
            break;
        }

        date.setDate(date.getDate() + daysToAdd);
        const str = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en_US');
        dateTimeControl.value = str;
        this.onDetailValueChange(true, str, 'isAddToCallList');
    }


    onCustomSmsFinished(e) {

    }

    getUser(UserId: string) {

    }

    getProcedureType(CaseProcedureId: string) {
        return '';
    }
    onOverrideSmsMessage(e) {
        this.isOverrideSms = e.checked;
        if (this.isOverrideSms) {
            this.generateSMSMessage();
        }
    }
    generateSMSMessage() {
        let detail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'customSms');
        if (!detail) {
            detail = new AppointmentDetailDataModel();
            detail.AppointmentId = this.data.appointment.AppointmentId;
            if (this.isOverrideSms) { // if override Sms, delete original from Details if exits
                const idx = this.data.appointment.dataAppoitmentDetails.findIndex(p => p.DetailParameterName === 'originalSms');
                if (idx > -1) {
                    this.data.appointment.dataAppoitmentDetails.splice(idx, 1);
                }
                detail.DetailParameterName = 'customSms';
            } else {// if original Sms, delete override sms from Details if exits
                const idx = this.data.appointment.dataAppoitmentDetails.findIndex(p => p.DetailParameterName === 'customSms');
                if (idx > -1) {
                    this.data.appointment.dataAppoitmentDetails.splice(idx, 1);
                }
                detail.DetailParameterName = 'originalSms';
            }
            this.data.appointment.dataAppoitmentDetails.push(detail);
        }

        let patientName = '<<Patient Name>>';
        let appointmentDate = '<<Appointment Date>>';
        let doctorName = '<<Doctor Name>>';

        const startTime = new Date(this.data.appointment.startDate).toLocaleDateString();
        appointmentDate = startTime;

        if (this.data.appointment.Label_DoctorId) {
            const doctor = this.returnDoctorById(this.data.appointment.Label_DoctorId);
            if (doctor) {
                doctorName = `Dr. ${doctor.dataContact.FirstName} ${doctor.dataContact.LastName}`;
            }
        }

        if (this.patient) {
            patientName = `${this.patient.dataContact.FirstName}`;
            if (this.patient.dataContact.LastName) {
                patientName += ' ' + `${this.patient.dataContact.LastName}`;
            }
        }

        detail.DetailParameterValue = `Hello ${patientName}, your appointment with ${doctorName} has been scheduled for ${appointmentDate}. You can access the Patient Portal here: <<Portal Login URL>> Please check your email for more details. Thank you`;
        this.customSmsMessage = detail.DetailParameterValue;
    }

    returnDoctorById(doctorId: string): DoctorDataModel {
        if (!this.data.allDoctors) {
            return;
        }
        const foundDoctor = this.data.allDoctors.find(doctor => doctorId === doctor?.DoctorId);

        if (foundDoctor) {
            return foundDoctor;
        }
    }

    //  patient search autocomplete ----------------------------------------------

    onAppointmentStatusChange(e: any) {
        if (!e.isUserInput) return;
        this.data.appointment.enumApptStatusId = e.value.ValidValueItemId;
    }

    onAppointmentTypeChange(e: any) {
        if (!e.isUserInput) return;
        this.data.appointment.enumApptTypeId = e.value.ValidValueItemId;
    }

    showBlockAppt() {

        //console.log('showBlockAppt', this.data.appointment.enumApptTypeId);





        if (this.data.appointment.enumApptTypeId == this.enumApptType_BlockIn  || this.data.appointment.enumApptTypeId == this.enumApptType_BlockOut)
        {
            return true;
        }
        else
        {
            return false;
        }

    }

    async onSaveClick() {
        if (this.isSaving) { return; }
        this.isSaving = true;

        // calculate start date enddate

        this.data.appointment.startDate = this.sLocalStartDate + ' ' + String(this.localStartTime.getHours()).padStart(2, '0') + ':' + String(this.localStartTime.getMinutes()).padStart(2, '0') + ':00';
        this.data.appointment.endDate = this.sLocalStartDate + ' ' + String(this.localEndTime.getHours()).padStart(2, '0') + ':' + String(this.localEndTime.getMinutes()).padStart(2, '0') + ':00';

        if (!(this.data.appointment.enumApptTypeId == this.enumApptType_BlockIn  || this.data.appointment.enumApptTypeId == this.enumApptType_BlockOut)) {
            if (!this.validateAppointmentFields()) {
                this.isSaving = false;
                return;
            }
        }
        else {
            if (!this.validateTimeSlotFields()) {
                this.isSaving = false;
                return;
            }
        }

        // Generate SMS message if Send SMS is checked
        const sendSmsDetail = this.data.appointment.dataAppoitmentDetails.find(p => p.DetailParameterName === 'sendSMS');
        if (sendSmsDetail && sendSmsDetail.DetailParameterValue === 'true') {
            // console.log('SMS generation triggered in EditAppointmentDialogComponent');
            this.generateSMSMessage();
        }

        // Check if referring doctor has changed or patient doesn't have one
        if (this.patient && this.data.appointment.PatientId && this.Referring_DoctorId && this.Referring_DoctorId.trim() !== '') {
            const hasReferringDoctorChanged = this.originalReferringDoctorId !== this.Referring_DoctorId;
            const patientHasAnyReferringDoctor = this.patient.dataPatientDoctors && 
                this.patient.dataPatientDoctors.some(pd => pd.isReferring === true);

            // Save referring doctor if it changed from original or if patient doesn't have any referring doctor
            if (hasReferringDoctorChanged || !patientHasAnyReferringDoctor) {
                    try {
                        //const referringDoctor = this.data.allDoctors.find(d => d.DoctorId.toLowerCase() === this.Referring_DoctorId.toLowerCase());
                        this.newReferringDoctor = await this.doctorsService.getDoctorById(this.Referring_DoctorId).toPromise();
                       
                        if (this.newReferringDoctor && this.newReferringDoctor.DoctorId) {
                            const dataPatientDoctor: PatientDoctorDataModel = new PatientDoctorDataModel();
                            dataPatientDoctor.DoctorID = this.Referring_DoctorId;
                            dataPatientDoctor.PatientId = this.data.appointment.PatientId;
                            dataPatientDoctor.isReferring = true;
                            
                            // Get the first active specialty if available
                            if (this.newReferringDoctor.dataDoctorSpecialties && this.newReferringDoctor.dataDoctorSpecialties.length > 0) {
                                const activeSpecialty = this.newReferringDoctor.dataDoctorSpecialties.find(s => !s.xauditDeleted);
                                dataPatientDoctor.DoctorSpecId = activeSpecialty ? activeSpecialty.DoctorSpecId : Constants.emptyGuid;
                            } else {
                                dataPatientDoctor.DoctorSpecId = Constants.emptyGuid;
                            }
                            
                            dataPatientDoctor.PracticeId = null;
                            
                            try {
                                await this.patientService.saveDataPatientReferralDoctor(dataPatientDoctor).toPromise();
                            } catch (err) {
                                console.error('Error saving referring doctor', err);
                                // Log error but don't prevent appointment from being saved
                            }
                        }
                    } catch (error) {
                        // Log error but don't prevent appointment from being saved
                        console.error('Error fetching referring doctor details:', error);
                        // Appointment save will continue even if referring doctor fetch/save fails
                    }
            }
        }
        

        if (this.isNewAppoitment === true) {
            this.data.appointment.isReservation = false;

            this.schedulingService.saveNewAppoitment(this.data.appointment).subscribe({
                next: res => {
                    if (this.isReferralRequest == true) {
                        this.schedulingService.updateReferralNewAppoitment(this.globals.ReferralAppointmentRequest.ReferralId, res.AppointmentId).subscribe(resa => {
                        });
                    }
                    this.dialogRef.close(res);
                },
                error: (error) => { 
                    console.error('Error saving appointment', error);
                    this.isSaving = false;
                    this.uiService.displayMessage('error', 'Error saving appointment');
                    this.changeDetectorRef.markForCheck();
                },
                complete: () => {
                    this.isSaving = false;
                    
                }
            });
        }
        else {
            // update
            this.data.appointment.isReservation = false;
            this.schedulingService.updateAppoitment(this.data.appointment).subscribe({
                next: res => { this.dialogRef.close(res); },
                error: (error) => { 
                    this.isSaving = false; 
                    this.changeDetectorRef.markForCheck(); 
                    console.error('Error updating appointment', error);
                    this.uiService.displayMessage('error', 'Error updating appointment');
                },
                complete: () => {
                    this.isSaving = false;
                    this.changeDetectorRef.markForCheck();
                }
            });
        }
    }

    onDeleteClick() {
        if (this.isSaving) { return; }
        // Same behavior as the "Delete Appointment" scheduler context-menu item:
        // confirm only (no notes), then mark the appointment Canceled so the backend
        // routes it to the Cancellations operatory + creates the cancellation task.
        this.dialogService.openConfirmDialog('Are you sure you want to delete this appointment?', false, true, 'Delete Appointment')
            .subscribe((result) => {
                if (result === true) {
                    this.isSaving = true;
                    this.data.appointment.enumApptStatusId = this.enumApptStatus_Canceled;
                    this.data.appointment.isReservation = false;
                    this.schedulingService.updateAppoitment(this.data.appointment).subscribe({
                        next: res => { this.dialogRef.close(res); },
                        error: () => { this.isSaving = false; }
                    });
                }
            });
    }

    validateTimeSlotFields(){
        let validationError = '';
        if (!this.sLocalStartDate) {
            validationError += 'Date missing<br/>';
        }
        if (!this.data.appointment.startDate) {
            validationError += 'Start Date Time missing<br/>';
        }
        if (!this.data.appointment.endDate) {
            validationError += 'End Date Time missing<br/>';
        }
        if (this.data.appointment.endDate <= this.data.appointment.startDate) {
            validationError += 'Start Date Time must be greater than End Date Time<br/>';
        }

        if (validationError != '') {
            this.uiService.displayMessage('error', validationError);
            return false;
        }
        return true;
    }
    validateAppointmentFields(){
        // validate required fileds
        if (!this.validateTimeSlotFields()) {
            return false;
        }
        let validationError = '';
        if (!this.data.appointment.PatientId) {
            validationError += 'Patient missing<br/>';
        }

        if (!this.data.appointment.ForProcedure) {
            validationError += 'Procedure is missing<br/>';
        }

        if (!this.data.appointment.Label_DoctorId) {
            validationError += 'Provider/Doctor is missing<br/>';
        }

        if (!this.Referring_DoctorId || this.Referring_DoctorId.trim() === '') {
            validationError += 'Referring Doctor is missing<br/>';
        }

        if (validationError != '') {
            this.uiService.displayMessage('error', validationError);
            return false;
        }
        return true;
    }
    onCancelClick() {



        if (this.data.appointment.Reservation_AppointmentId == null) {
            this.dialogRef.close(null);
        }
        else {

            try {

                this.schedulingService.removeAppointmentReservation(this.data.appointment.Reservation_AppointmentId).subscribe(
                    (res) => {

                        if (res != 'OK') {
                            this.uiService.displayMessage('error', res);
                        }
                        this.dialogRef.close(null);
                    }
                );
            }
            catch (e) {
                console.error('Error removing appointment reservation', e);
                this.uiService.displayMessage('error', 'Error removing appointment reservation');
            }
        }
    }
}
